import React, { useEffect, useState } from "react";
import "./AssessmentCrud.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCopy,
  faEye,
  faPenToSquare,
  faTrashCan,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
//import sortByAssessmentName from '../sortingHelper';

const config = require("../../config.js");
const translations = {
  english: {
    name: "Name",
    company: "Company",
    email: "Email",
    category: "Category",
    language: "Language",
    year: "Year",
    filters: "Filters",
    selectLanguage: "Select Language",
    action: "Actions",
    null: "Null",
    fiscalYear: "Fiscal Year",
    status: "Status",
    report: "Report",
    third: "3rd Party",
    certificate: "Verification",
    documents: "Expert Report",
    visible: "Visible",
    activity: "Activity",
  },
  german: {
    name: "Name",
    company: "Unternehmen",
    email: "E-Mail",
    category: "Kategorie",
    language: "Sprache",
    year: "Jahr",
    filters: "Filter",
    selectLanguage: "Sprache wählen",
    action: "Aktionen",
    null: "Null",
    fiscalYear: "Geschäftsjahr",
    status: "Status",
    report: "Bericht",
    third: "Drittanbieter",
    certificate: "Verifikation",
    documents: "Sachverständigenbericht",
    visible: "Sichtbar",
    activity: "Aktivität",
  },
  czech: {
    name: "Jméno",
    company: "Společnost",
    email: "E-mail",
    category: "Kategorie",
    language: "Jazyk",
    year: "Rok",
    filters: "Filtry",
    selectLanguage: "Vyberte jazyk",
    action: "Akce",
    null: "Nil",
    fiscalYear: "Hospodářský rok",
    status: "Stav",
    report: "Zpráva",
    third: "Třetí strana",
    certificate: "Ověření",
    documents: "Odborná zpráva",
    visible: "Viditelné",
    activity: "Aktivita",
},
  italian: {
    name: "Nome",
    company: "Azienda",
    email: "Email",
    category: "Categoria",
    language: "Lingua",
    year: "Anno",
    filters: "Filtri",
    selectLanguage: "Seleziona Lingua",
    action: "Azioni",
    null: "Nullo",
    fiscalYear: "Anno Fiscale",
    status: "Stato",
    report: "Rapporto",
    third: "Terza Parte",
    certificate: "Verifica",
    documents: "Rapporto Esperto",
    visible: "Visibile",
    activity: "Attività",
  },
};

function AssessmentCrudExpert() {
  const [assessments, setAssessments] = useState([]);
  const navigate = useNavigate();
  const [filteredAssessments, setFilteredAssessments] = useState([]);

  const fetchAssessments = async () => {
    try {
      const response = await fetch(
        config.env.API_BASE_URL + "/api/results/expert",
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      );
      if (response.ok) {
        const data = await response.json();
        setAssessments(data);
        setFilteredAssessments(data);
      } else {
        console.error("Failed to fetch assessments");
      }
    } catch (error) {
      console.error("Error fetching assessments:", error);
    }
  };

  useEffect(() => {
    fetchAssessments(); // Fetch assessments on component mount
  }, []);

  const GotoViewAnswer = (result) => {
    navigate("/take-assessment", {
      state: {
        examName: result.examName,
        examCategory: result.examCategory,
        isMSS: result.isMSS,
        assessmentId: result.assessmentId._id,
        disabled: true,
        edit: true,
        resultId: result._id,
      },
    });
  };

  const calculateTable = () => {
    let newAssessments = assessments.filter((myAssessments) => {
      if (
        myAssessments.userId.name
          .toLowerCase()
          .includes(myFilters.name.toLowerCase()) &&
        myAssessments.userId.email
          .toLowerCase()
          .includes(myFilters.email.toLowerCase()) &&
        myAssessments.userId.companyName
          .toLowerCase()
          .includes(myFilters.companyName.toLowerCase()) &&
        myAssessments.assessmentId.examCategory
          .toLowerCase()
          .includes(myFilters.category.toLowerCase()) &&
        myAssessments.assessmentId.language
          .toLowerCase()
          .includes(myFilters.language.toLowerCase()) &&
        myAssessments.year.toLowerCase().includes(myFilters.year.toLowerCase())
      ) {
        return true;
      } else {
        return false;
      }
    });
    setFilteredAssessments(newAssessments);
  };

  let myFilters = {
    name: "",
    email: "",
    companyName: "",
    category: "",
    language: "",
    year: "",
  };

  const [currentLanguage] = useState(
    localStorage.getItem("language") || "english"
  );

  let lang = translations[currentLanguage];

  return (
    <>
      <div
        className="mt-5 Crud-main-container container"
        style={{ color: "#9C9CA5" }}
      >
        <div style={{ fontSize: "24px" }}>{lang.filters}</div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            marginTop: "16px",
            marginBottom: "16px",
            gap: "24px",
            paddingLeft: "12px",
            paddingRight: "12px",
            placeContent: "center",
          }}
        >
          <div>
            <div
              style={{ fontSize: "16px", color: "#9C9CA5", textAlign: "left" }}
            >
              {lang.name}
            </div>
            <input
              placeholder={lang.name}
              onChange={(event) => {
                myFilters.name = event.target.value;
                calculateTable();
              }}
              style={{
                background: "white",
                width: "200px",
                color: "#9C9CA5",
                borderRadius: "16px",
                paddingTop: "4px",
                paddingBottom: "4px",
                paddingLeft: "12px",
              }}
            ></input>
          </div>
          <div>
            <div
              style={{ fontSize: "16px", color: "#9C9CA5", textAlign: "left" }}
            >
              {lang.email}
            </div>
            <input
              placeholder={lang.email}
              onChange={(event) => {
                myFilters.email = event.target.value;
                calculateTable();
              }}
              style={{
                background: "white",
                width: "200px",
                color: "#9C9CA5",
                borderRadius: "16px",
                paddingTop: "4px",
                paddingBottom: "4px",
                paddingLeft: "12px",
              }}
            ></input>
          </div>
          <div>
            <div
              style={{ fontSize: "16px", color: "#9C9CA5", textAlign: "left" }}
            >
              {lang.company}
            </div>
            <input
              placeholder={lang.company}
              onChange={(event) => {
                myFilters.companyName = event.target.value;
                calculateTable();
              }}
              style={{
                background: "white",
                width: "200px",
                color: "#9C9CA5",
                borderRadius: "16px",
                paddingTop: "4px",
                paddingBottom: "4px",
                paddingLeft: "12px",
              }}
            ></input>
          </div>
          <div>
            <div
              style={{ fontSize: "16px", color: "#9C9CA5", textAlign: "left" }}
            >
              {lang.category}
            </div>
            <input
              placeholder={lang.category}
              onChange={(event) => {
                myFilters.category = event.target.value;
                calculateTable();
              }}
              style={{
                background: "white",
                width: "200px",
                color: "#9C9CA5",
                borderRadius: "16px",
                paddingTop: "4px",
                paddingBottom: "4px",
                paddingLeft: "12px",
              }}
            ></input>
          </div>
          <div>
            <div
              style={{ fontSize: "16px", color: "#9C9CA5", textAlign: "left" }}
            >
              {lang.language}
            </div>
            <input
              placeholder={lang.language}
              onChange={(event) => {
                myFilters.language = event.target.value;
                calculateTable();
              }}
              style={{
                background: "white",
                width: "200px",
                color: "#9C9CA5",
                borderRadius: "16px",
                paddingTop: "4px",
                paddingBottom: "4px",
                paddingLeft: "12px",
              }}
            ></input>
          </div>
          <div>
            <div
              style={{ fontSize: "16px", color: "#9C9CA5", textAlign: "left" }}
            >
              {lang.year}
            </div>
            <input
              placeholder={lang.year}
              onChange={(event) => {
                myFilters.year = event.target.value;
                calculateTable();
              }}
              style={{
                background: "white",
                width: "200px",
                color: "#9C9CA5",
                borderRadius: "16px",
                paddingTop: "4px",
                paddingBottom: "4px",
                paddingLeft: "12px",
              }}
            ></input>
          </div>
        </div>
        <table className="table Crud-main container">
          <thead>
            <tr className="Crud-thead-wrapper">
              <th scope="col">{lang.name}</th>
              <th scope="col">{lang.email}</th>
              <th scope="col">{lang.company}</th>
              <th scope="col">{lang.category}</th>
              <th scope="col">{lang.language}</th>
              <th scope="col">{lang.year}</th>
              <th scope="col">{lang.action}</th>
            </tr>
          </thead>
          <tbody>
            {filteredAssessments
              .slice()
              //.sort(sortByAssessmentName)
              .map((assessment) => (
                <tr key={assessment._id}>
                  <td>{assessment.userId.name}</td>
                  <td>{assessment.userId.email}</td>
                  <td>{assessment.userId.companyName}</td>
                  <td>{assessment.examCategory}</td>
                  <td>{assessment.assessmentId.language}</td>
                  <td>{assessment.year}</td>
                  <td
                    className="view-exam-icon"
                    onClick={() =>
                      GotoViewAnswer(
                        assessment
                      )
                    }
                  >
                    <FontAwesomeIcon icon={faEye} /> View Answer
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

export default AssessmentCrudExpert;
